import notifications from './notifications.js';
import { setDesktopCookies } from './store/cookies.js';
import login from './login.js';

function getTextValues(forgottenPasswordElement) {
	return {
		title: forgottenPasswordElement.dataset.title,
		message: forgottenPasswordElement.dataset.message,
		button: forgottenPasswordElement.dataset.button,
		desktopLink: forgottenPasswordElement.dataset.desktopLink,
		desktopLinkButtonText: forgottenPasswordElement.dataset.desktopButtonText
	};
}

function getForgottenPasswordConfirmationClickHandler(forgottenPasswordElement) {
	const texts = getTextValues(forgottenPasswordElement);
	return function forgottenPasswordButtonClickHandler(event) {
		notifications.showBinaryQuestion(texts.title, texts.desktopLinkButtonText, texts.button,
			() => {
				setDesktopCookies();
				window.location.href = texts.desktopLink;
			}, () => {
				notifications.hideNotification();
				login.openLoginFrom();
			}, texts.message);
		login.closeLoginForm();
		event.preventDefault();
		event.stopPropagation();
	};
}

function init(loginElem) {
	const forgottenPasswordElement = loginElem.getElementsByClassName('js-forgotten-password')[0];
	forgottenPasswordElement.onclick = getForgottenPasswordConfirmationClickHandler(forgottenPasswordElement);
}

export default {
	init
};



// WEBPACK FOOTER //
// ./mobile-core/src/forgotten-password.js